import { Navigate } from 'react-router-dom'

import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { paths } from '@/constants/paths'
import { Account } from '@/containers/Account'
import { Developer } from '@/containers/Developer'
import { Region } from '@/containers/Region'
import { SettingsPage } from '@/containers/SettingsPage'
import { SmartPreview } from '@/containers/SmartPreview'
import {
  Imprint,
  DataPrivacy,
  TermsConditions,
} from '@/containers/StaticHTMLPage'
import { Subscriptions } from '@/containers/Subscriptions'
import { Consent } from '@/containers/Usercentrics/Consent'
import { TestYouTubePlayer } from '@/containers/YouTube/TestYouTubePlayer'

import { RouteConfig } from './routes'

const devModeSettingsRoutes: RouteConfig[] = isDevMode
  ? [
      {
        path: paths.SETTINGS_DEVELOPER,
        element: <Developer />,
      },
      {
        path: paths.SETTINGS_SMART_PREVIEW,
        element: <SmartPreview />,
      },
      {
        path: `${paths.SETTINGS}/youtube`,
        element: <TestYouTubePlayer />,
      },
      {
        path: `${paths.SETTINGS}/hls-ads-player`,
        element: <SettingsPage title="HLS Ads Player" />,
      },
    ]
  : []

export const settingsRoutes = [
  {
    index: true,
    path: '',
    element: <Navigate to={paths.SETTINGS_ACCOUNT} />,
  },
  {
    path: paths.SETTINGS_SUBSCRIPTIONS,
    element: <Subscriptions />,
  },
  {
    path: paths.SETTINGS_ACCOUNT,
    element: <Account />,
  },
  {
    path: paths.SETTINGS_IMPRINT,
    element: <Imprint />,
  },
  {
    path: paths.SETTINGS_DATA_PRIVACY,
    element: <DataPrivacy />,
  },
  {
    path: paths.SETTINGS_TERMS_CONDITIONS,
    element: <TermsConditions />,
  },
  {
    path: paths.SETTINGS_REGION,
    element: <Region />,
  },
  {
    path: paths.SETTINGS_COOKIE_BANNER,
    element: <Consent />,
  },
  ...devModeSettingsRoutes,
]
